import React, { Component, Fragment } from 'react';
import Topping from './selectors/Topping';

export default class ToppingModifierContent extends Component {
    constructor(props) {
        super(props);
        this.generateJSXFromData = this.generateJSXFromData.bind(this);
    }

    generateJSXFromData() {
        var result = this.props.modifiers.map( (val, ind, arr) => {
            const mod = this.props.allModifiers[val];
            const choice = this.props.choices[val];
            return <Topping
                key={ind}
                modifierKey={val}
                name={mod.name}
                matrixWeight={mod.matrixWeight}
                priceLevels={mod.priceLevels}
                showDouble={mod.showDouble}
                showHalf={mod.showHalf}
                setFirstHalf={this.props.setFirstHalf}
                setSecondHalf={this.props.setSecondHalf}
                setWhole={this.props.setWhole}
                setExtra={this.props.setExtra}
                setLight={this.props.setLight}
                setNormal={this.props.setNormal}
                removeModifier={this.props.removeModifier}
                choice={choice}
                showDouble={mod.showDouble}
                showHalf={mod.showHalf}
                toppingIndex={ind}
                mod={mod}
                selectedMainItem={this.props.selectedMainItem}
                itemGroup={this.props.itemGroup}
            />
        });

        return result;
    }

    render() {
        return (
            <div className="card-body p-0">
                {this.generateJSXFromData()}
            </div>
        );
    }
}

{/*<div id={`collapse${this.props.bootstrapID}`} className={`collapse ${this.props.shouldShow ? 'show' : ''}`} aria-labelledby={`heading${this.props.bootstrapID}`} data-parent="#availableModifierGroups">*/}
    {/*<div className="card-body p-0">*/}
        {/*{this.generateJSXFromData()}*/}
    {/*</div>*/}
{/*</div>*/}